import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksTraits } from '@olagg/api-hooks';
import TraitForm from './Form';
import { CreateCardDeckTraitData } from '@olagg/db-types';
import { Center, VStack, Heading } from '@chakra-ui/react';

export const CreateTrait = () => {
  const navigate = useNavigate();
  const { deck_id } = useParams();

  if (!deck_id) return null;
  
  const { createTrait } = useAdminCardDecksTraits(deck_id);

  const handleSubmit = async (data: CreateCardDeckTraitData) => {
    await createTrait(data);
    navigate(generatePath(ROUTES.CARD_DECKS.traits.all, { deck_id }));
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Crear Trait
        </Heading>
        <TraitForm onSubmit={handleSubmit} />
      </VStack>
    </Center>
  );
};
